import React, { useContext } from 'react'
import {cartContext}from'../Contexts/CartContext';
import googleplay from '../../assets/google-play.png';
function Footer() {
    let {check}=useContext(cartContext);
  return <>
  
  {check?<div style={{backgroundColor:'#F0F3F2'}}><div className="container mt-5 pt-5 " style={{backgroundColor:'#F0F3F2'}}>
    <div className="row">
        <div className="col-sm-8">
            <div className="sec1">
                <p>Get the FreshCart app</p>
                <h6 className='text-muted '>We will send you a link open it on your phone to download the app</h6>
                <input type="email" name="email" id="email"  className='form-control mt-3 shadow-none border-1' placeholder='Email'/>
            </div></div>
            <div className="col-sm-4">
            <div className="sec2 pt-5  ">
                <button className='btn bg-main text-white mt-4  '>Share App Link</button>
            </div></div>
        </div>
        <div className="row">
        <div className="col-sm-6">
            <div className="sec1 mt-5">
                <span>Payment Partners </span><i className="fa-brands fa-cc-amazon-pay fs-3 ms-2 " style={{color:'#FAB005'}}></i><i className="fa-brands fa-cc-mastercard fs-3 ms-2" style={{color:'#F75C00'}}></i> <i className="fa-brands fa-cc-paypal fs-3 ms-2 text-info" ></i>
            </div></div>
            <div className="col-sm-12 col-lg-6">
            <div className="sec2 pt-5 d-flex mb-5">
                <span>Get deliveries with FreshCart</span>
                <span className='btn bg-dark text-white  ms-1 h6 '><img src={googleplay} alt="googleplay" width={20} />  Google Play</span>
                <span className='btn bg-dark text-white  ms-1  h6'><i className="fa-brands fa-app-store-ios"></i> App Store</span>
            </div></div>
        </div>
    </div></div>:''}
  
  
  
  </>
}

export default Footer
